const SectionHeroTemplate = () => `
  <section class="app-hero">
    <div class="app-hero__info" style="width: 850px; height: auto">
      <h1>Culinaria</h1>
      <p>Explore new and exciting restaurants with ease through our user-friendly app. Find the perfect spot for any
        occasion. Discover new culinary experiences today!</p>
      <a href="#restaurantContent" tabindex="-1" class="hero-btn">Explore Now</a>
    </div>
    <div class="app-hero__img">
      <picture>
        <source media="(max-width: 780px)" srcset="./assets/hero-img-small.jpg">
        <img 
          class="lazyload hero-image" 
          data-src="./assets/hero-img-large.jpg"
          alt="hero image"
        >
      </picture>
    </div>
  </section>
`

export default SectionHeroTemplate
